export const colorTemplate = (option) => {
  if (!option?.image) {
    return null; // Or handle the case in another way
  }
  return (
    <div className="color-option">
      <img
        className="color-square"
        src={`${process.env.REACT_APP_IMG_URL}${option.image}`}
        alt={option.name}
      />
      <div className="color-label">{option.name}</div>
    </div>
  );
};
